// ============================================================
// rovingIndex - where an arrow key moves the focus in a list that
// takes one tab stop (the order rail's rows, the tab bar before it).
//
// Down and Right step forward, Up and Left step back, both wrapping;
// Home and End jump to the ends. Any other key is not navigation.
// ============================================================

const STEP = new Map<string, number>([
  ['ArrowDown', 1],
  ['ArrowRight', 1],
  ['ArrowUp', -1],
  ['ArrowLeft', -1],
]);

/**
 * The index `key` moves to from `index` in a list of `length`, or null
 * when the key is not navigation or the list is empty. `index` may be -1
 * (nothing focused yet): a step forward then lands on the first item.
 */
export function rovingIndex(key: string, index: number, length: number): number | null {
  if (length === 0) return null;
  const step = STEP.get(key);
  if (step !== undefined) return (index + step + length) % length;
  if (key === 'Home') return 0;
  if (key === 'End') return length - 1;
  return null;
}
